import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import {
    Form,
    Input,
    Row,
    Col,
    Button,
    Rate,
    Modal,
    Avatar,
} from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { required, whiteSpace, maxLengthC } from '../config/FormValidation'
import { langs } from '../config/localization';
import { addBookingReviewAction, editBookingReviewAction } from '../store/actions'
import { MESSAGES } from '../config/Message'
import { dateFormate5 } from '../components/common'
import { Fragment } from 'react';
import { replaceImageURL } from '../common/Navigation';
const { TextArea } = Input;

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 15, offset: 1 },
    labelAlign: 'left',
    colon: false,
};

class LeaveFeedbackModel extends React.Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            accurate: 0,
            communication: 0,
            reasonable: 0,
            postage: 0
        };
    }

    componentDidMount() {
        const { selectedReview } = this.props
        if (selectedReview) {
            this.setState({
                accurate: Number(selectedReview.accurate_description),
                communication: Number(selectedReview.communication),
                reasonable: Number(selectedReview.reasonable_postage_costs),
                postage: Number(selectedReview.postage_speed),
            })
            this.formRef.current.setFieldsValue({
                title: selectedReview.title,
                comment: selectedReview.review
            });
        }
    }

    /**
     * @method onFinish
     * @description handle on submit
     */
    onFinish = (values) => {
        const { classifiedDetail, selectedReview } = this.props
        const { accurate, reasonable, postage, communication } = this.state
        let label = accurate === 0 ? 'accurate description' : reasonable === 0 ? 'Reasonable postage costs' : postage === 0 ? 'Postage speed' : 'Communication'
        if (accurate && reasonable && postage && communication) {

            let review_id = selectedReview?.id;
            if (review_id) {
                const requestData = {
                    review_id: review_id,
                    title: values.title,
                    module: this.props.module,
                    comment: values.comment,
                    accurate_description: accurate,
                    reasonable_postage_costs: reasonable,
                    postage_speed: postage,
                    communication: communication
                };
                this.props.editBookingReviewAction(requestData, (res) => {
                    if (res.success) {
                        this.props.callNext();
                        toastr.success(langs.success, MESSAGES.REVIEW_UPDATE_SUCCESS);
                        this.props.onCancel();
                    }
                });
            } else {
                const requestData = {
                    retail_classified_id: classifiedDetail?.id,
                    title: values.title,
                    module: this.props.module,
                    comment: values.comment,
                    accurate_description: accurate,
                    reasonable_postage_costs: reasonable,
                    postage_speed: postage,
                    communication: communication
                }
                this.props.addBookingReviewAction(requestData, res => {
                    if (res.success) {
                        this.props.callNext()
                        toastr.success(langs.success, MESSAGES.REVIEW_ADD_SUCCESS)
                        this.props.onCancel()
                    }
                })

            }
        } else {
            toastr.warning(`Please select rating for ${label}`)
        }

    }


    /**
     * @method render
     * @description render component
     */
    render() {
        const { visible, classifiedDetail, selectedReview } = this.props;
        const { accurate, reasonable, postage, communication } = this.state
        return (
            <Modal
                title='Leave a Feedback'
                visible={visible}
                className={'custom-modal style1 retail-leave-feedback-style'}
                footer={false}
                onCancel={this.props.onCancel}
            >
                <div className='padding'>
                    <Row className='mb-15'>
                        <Col md={20}>
                            <div className='reviews-content-left'>
                                <div className='reviews-content-avatar'>
                                    <Avatar
                                        src={replaceImageURL(classifiedDetail?.classified_user?.image ?? selectedReview?.review_for_image, 53, 53)}
                                        size={53}
                                        className=''
                                    />
                                </div>
                                <div className='reviews-content-avatar-detail'>
                                    <div className="name-tile">
                                        {`${classifiedDetail?.classified_user ? classifiedDetail.classified_user.name : selectedReview?.review_for ?? ""}`}
                                    </div>
                                    <div className="memeber-date">
                                        {classifiedDetail?.classified_user ?
                                            `Member since  ${dateFormate5(classifiedDetail.classified_user.created_at)} Based in ${classifiedDetail.classified_business.business_city ? classifiedDetail.classified_business.business_city : ''}` :
                                            ""}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Form
                        {...layout}
                        name='basic'
                        onFinish={this.onFinish}
                        ref={this.formRef}
                    >
                        <Form.Item
                            label='Title'
                            name='title'
                            rules={[required(''), whiteSpace('Title'), maxLengthC(100)]}
                            className="custom-astrix"
                        >
                            <Input placeholder={'...'} className='shadow-input' />
                        </Form.Item>
                        <Form.Item
                            label='Comment'
                            name='comment'
                            rules={[required(''), whiteSpace('Review'), maxLengthC(300)]}
                            className="custom-astrix"
                        >
                            <TextArea rows={4} placeholder={'Write comments here...'} className='shadow-input' />
                        </Form.Item>
                        <Fragment>
                            <div className="pro-ratting-label">
                                <Row align="middle">
                                    <Col md={8}>
                                        <h2>Select your rating</h2>
                                    </Col>
                                    <Col md={14}>
                                        <div className="rating-comment">
                                            <div className="first">
                                                <p>1</p>
                                                <p>Terrible</p>
                                            </div>
                                            <div className="second">
                                                <p>2</p>
                                                <p>Poor</p>
                                            </div>
                                            <div className="third">
                                                <p>3</p>
                                                <p>Average</p>
                                            </div>
                                            <div className="four">
                                                <p>4</p>
                                                <p>Very good</p>
                                            </div>
                                            <div className="five">
                                                <p>5</p>
                                                <p>Excellent</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={8}>
                                        <div className="label-title">Accurate description</div>
                                    </Col>
                                    <Col md={14}>
                                        <div className="rate-for-pro">
                                            <Rate allowHalf value={accurate} onChange={(e) => this.setState({ accurate: e })} />
                                        </div>
                                    </Col>

                                    <Col md={8}>
                                        <div className="label-title">Reasonable postage costs</div>
                                    </Col>
                                    <Col md={14}>
                                        <div className="rate-for-pro">
                                            <Rate allowHalf value={reasonable} onChange={(e) => this.setState({ reasonable: e })} />
                                        </div>
                                    </Col>

                                    <Col md={8}>
                                        <div className="label-title">Postage speed</div>
                                    </Col>
                                    <Col md={14}>
                                        <div className="rate-for-pro">
                                            <Rate allowHalf value={postage} onChange={(e) => this.setState({ postage: e })} />
                                        </div>
                                    </Col>

                                    <Col md={8}>
                                        <div className="label-title">Communication</div>
                                    </Col>
                                    <Col md={14}>
                                        <div className="rate-for-pro">
                                            <Rate allowHalf value={communication} onChange={(e) => this.setState({ communication: e })} />
                                        </div>
                                    </Col>
                                </Row>

                            </div>
                        </Fragment>
                        <Fragment>
                            <Row>
                                <Col md={24}>
                                    <div className="pt-20 text-center">
                                        <Button type='default' htmlType='submit'>Send</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Fragment>
                    </Form>
                </div>
            </Modal>
        );
    }
}

//  Connect with redux through connect methode
const mapStateToProps = (store) => {
    const { auth: { loggedInUser } } = store;
    return { loggedInUser };
};

export default connect(mapStateToProps, { addBookingReviewAction, editBookingReviewAction })(LeaveFeedbackModel);
